import React from "react";
import { Link } from "react-router-dom";

interface IAdminLinkProps {
  id: string;
  linkText?: string;
  children?: any;
}
const AdminLink: React.FC<IAdminLinkProps> = ({ id, linkText, children }) => {
  if (!id) return <>{children}</>;

  const pathToClassDetail = `/profile/${id?.trim()}`;
  return (
    <Link
      to={pathToClassDetail}
      target={"_blank"}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <span className="font_semibold text-primary-blue">
        {linkText || children}
      </span>
    </Link>
  );
};

export default AdminLink;
